import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import { userOperations } from "../redux/user";
import SignIn from "./../pages/SignIn";
import SignOut from './../pages/SignOut';
import Activate from "./../pages/Activate";
import SummaryReport from "./../pages/SummaryReport";
import MagnetReport from "./../pages/MagnetReport";
import SharedSummaryReport from "./../pages/SharedSummaryReport";
import Observations from "./../pages/Observations";
import LandingPage from "./../pages/LandingPage";
import qs from "query-string";

class MainRouter extends Component {
  constructor(props) {
    super(props);
    this.props.dispatch(userOperations.validateSession());
    if (!props.user.authenticationServerUrl) {
      this.props.dispatch(userOperations.getAuthenticationServerUrl());
    }
  }

  render() {
    const { user } = this.props;

    if (!user.isLoggedIn) {
      if (user.sessionChecked) {
        const referrer = user.justSignedOut ? "" : `referrer=${window.location.pathname}`;
        const search = window.location.search ? `${window.location.search}&${referrer}` : `?${referrer}`;
        return (
          <BrowserRouter>
            <Switch>
              <Route exact path="/shared-summary-reports/:token?" component={SharedSummaryReport} />
              <Route exact path="/sign-in" component={SignIn} />
              <Route exact path="/sign-out" component={SignOut} />
              <Route exact path="/activate" component={Activate} />
              <Redirect
                to={{
                  pathname: user.nameID && user.system === 'GVH' ? '/sign-out' : "/sign-in",
                  search,
                }}
              />
            </Switch>
          </BrowserRouter>
        );
      } else {
        return (
          <Dimmer active>
            <Loader />
          </Dimmer>
        );
      }
    }

    const email = qs.parse(window.location.search).email;
    if (email && user.username !== email) {
      this.props.dispatch(userOperations.signOut());
    }

    return (
      <div>
        <BrowserRouter>
          <Switch>
            <Route exact path="/sign-in" component={SignIn} />
            <Route exact path="/sign-out" component={SignOut} />
            <Route exact path="/activate" component={Activate} />
            <Route exact path="/shared-summary-reports/:token?" component={SharedSummaryReport} />
            <Route exact path="/summary-reports/:id?" component={SummaryReport} />
            <Route exact path="/magnet-reports/:id?" component={MagnetReport} />
            <Route exact path="/observations" component={Observations} />
            <Route exact path="/" component={LandingPage} />
            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default connect(store => {
  return {
    user: store.user,
  };
})(MainRouter);



// WEBPACK FOOTER //
// ./src/modules/MainRouter.js